import app from '../../app';
import Login from '../../templates/views/Account/Login';

export default {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    title: t => t('login.signin', 'local')
  },
  beforeEnter: (to, from, next) => {
    if (app.authentication.isLoggedIn())
      next({ name: 'Alerts' })
    else
      next()
  }
};
